var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Resolve kinds, list catalog entries, and look up metadata.
 */
import { PIPELINE_CATALOG } from './catalog';
import { PIPELINE_ALIASES } from './aliases';
var KIND_SET = new Set(PIPELINE_CATALOG.map(function (r) { return r[0]; }));
export function resolvePipelineSymbolKind(input) {
    var raw = String(input || '')
        .trim()
        .replace(/[\s-]+/g, '_');
    var lower = raw.toLowerCase();
    if (KIND_SET.has(raw))
        return raw;
    if (PIPELINE_ALIASES[raw])
        return PIPELINE_ALIASES[raw];
    if (PIPELINE_ALIASES[lower])
        return PIPELINE_ALIASES[lower];
    if (KIND_SET.has(lower))
        return lower;
    var camel = lower.replace(/_([a-z])/g, function (_, c) { return c.toUpperCase(); });
    if (KIND_SET.has(camel))
        return camel;
    if (PIPELINE_ALIASES[camel])
        return PIPELINE_ALIASES[camel];
    return 'process';
}
export function listPipelineSymbols(category) {
    return PIPELINE_CATALOG.filter(function (_a) {
        var _b = __read(_a, 3), cat = _b[2];
        return !category || cat === category;
    }).map(function (_a) {
        var _b = __read(_a, 3), kind = _b[0], label = _b[1], cat = _b[2];
        return ({
            kind: kind,
            label: label,
            category: cat,
        });
    });
}
export function listPipelineSymbolCategories() {
    var e_1, _a;
    var seen = new Set();
    var out = [];
    try {
        for (var PIPELINE_CATALOG_1 = __values(PIPELINE_CATALOG), PIPELINE_CATALOG_1_1 = PIPELINE_CATALOG_1.next(); !PIPELINE_CATALOG_1_1.done; PIPELINE_CATALOG_1_1 = PIPELINE_CATALOG_1.next()) {
            var _b = __read(PIPELINE_CATALOG_1_1.value, 3), cat = _b[2];
            if (!seen.has(cat)) {
                seen.add(cat);
                out.push(cat);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (PIPELINE_CATALOG_1_1 && !PIPELINE_CATALOG_1_1.done && (_a = PIPELINE_CATALOG_1.return)) _a.call(PIPELINE_CATALOG_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
export function getPipelineSymbolMeta(kind) {
    var resolved = resolvePipelineSymbolKind(kind);
    var row = PIPELINE_CATALOG.find(function (_a) {
        var _b = __read(_a, 1), k = _b[0];
        return k === resolved;
    });
    if (row)
        return { kind: row[0], label: row[1], category: row[2] };
    return { kind: resolved, label: resolved, category: 'flow' };
}
